import { HubConnection } from '@microsoft/signalr';

import { ReturnToHospitalDto } from '@medone/medonehp-api-client';

import { store } from '../../../../../shared/store';
import { fetchReturnToHospitalCount } from '../../slice';

const onReturnToHospitalAdded = (_dto: ReturnToHospitalDto) => {
    store.dispatch(fetchReturnToHospitalCount());
};

export const removeReturnToHospitalHubConnection = (connection: HubConnection) => {
    connection.off('ReturnToHospitalAdded', onReturnToHospitalAdded);
};

export const initReturnToHospitalHubConnection = (connection: HubConnection) => {
    connection.on('ReturnToHospitalAdded', onReturnToHospitalAdded);
};
